import React, { useEffect, useState } from "react";
import { Tab } from "@mui/material";
import Box from "@mui/material/Box";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import TanseedJuryPendingList from "./TanseedJuryPendingList";
import TanseedAllJuryPendingList from "./TanseedAllJuryPendingList";

const JuryAssociatedTanseedList = () => {

    const [value, setValue] = useState(localStorage.getItem('tanseedTab') || "1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
        localStorage.setItem('tanseedTab', newValue)
    };
    // useEffect(() => {
    //     handleLocalStorageClear()
    // }, []);
    const handleLocalStorageClear = () => {
        localStorage.removeItem("tanseedJuryPendingList");
        localStorage.removeItem("tanseedJuryAllSearchList");
        localStorage.removeItem("rowsPerPageScst");
        localStorage.removeItem("pageScst");
        localStorage.setItem("approvalPending", "true");
    }
    const handleLocalStorageClear2 = () => {
        localStorage.removeItem("tanseedJuryPendingList");
        localStorage.removeItem("tanseedJuryAllSearchList");
        localStorage.removeItem("rowsPerPageScst");
        localStorage.removeItem("pageScst");
        localStorage.setItem("approvalPending", "false");
    }
    return (
        <div className="scsthub-div form_div chart">
            {/* <div className='header_tag'>
                <h5>TANSEED List</h5>
            </div> */}
            <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            <Tab label="Approval Pending" value="1" onClick={handleLocalStorageClear} />
                            <Tab label="All Startups" value="2" onClick={handleLocalStorageClear2} />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <TanseedJuryPendingList path={"jury/tanseed"} value={"tanseed"} />
                    </TabPanel>
                    <TabPanel value="2" >
                        <TanseedAllJuryPendingList path={"jury/tanseed"} value={"tanseed"}/>
                    </TabPanel>
                    {/* <TabPanel value="3" >
                        <TanseedSettings />
                    </TabPanel> */}
                </TabContext>
            </Box>
        </div>
    );
};

export default JuryAssociatedTanseedList;
